import cx from 'classnames'
import Styles from 'components/StageActions/StageActions.module.scss'
import { CheckThick } from 'almanac-ui/icons'

export const CheckIcon = ({ className }: { className?: string }) => (
  <span className={cx(className, Styles.icon, Styles.checkIcon)}>
    <CheckThick />
  </span>
)
